(function() {
  'use strict';

  angular.module('blocks.i18n', []);
})();
